import React from 'react';
import PropTypes from 'prop-types';

import ReactPaginate from 'react-paginate';

const Pagination = ({ current, totalItems, pageSize, onChange }) => {
  if (!totalItems || !pageSize || totalItems < pageSize) return null;
  const totalPages = Math.ceil(totalItems / pageSize);

  return (
    <nav
      className="pagination-container react-paginate"
      aria-label="Pagination"
    >
      <ReactPaginate
        previousLabel={'<'}
        nextLabel={'>'}
        breakLabel={'...'}
        initialPage={current}
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        onPageChange={page => onChange(page.selected)}
        containerClassName={'pagination pagination-lg'}
        breakClassName={'page-item'}
        breakLinkClassName={'page-link'}
        previousClassName={'page-item'}
        previousLinkClassName={'page-link'}
        nextClassName={'page-item'}
        nextLinkClassName={'page-link'}
        pageClassName={'page-item'}
        pageLinkClassName={'page-link'}
        activeClassName={'active'}
      />
    </nav>
  );
};

Pagination.propTypes = {
  current: PropTypes.number,
  totalItems: PropTypes.number,
  pageSize: PropTypes.number,
  onChange: PropTypes.func,
};

export default Pagination;
